import { useEffect } from 'react';

import { oidcService } from '../../services/oidcService';

const AuthLogoutPage: React.FC = () => {
  useEffect(() => {
    void oidcService.logout();
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <p className="text-gray-500">Signing out...</p>
    </div>
  );
};

export default AuthLogoutPage;
